export default __webpack_public_path__ + "static/media/ic_right.65640533.svg";